import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
require(`../assets/${process.env.PAGE}/css/components/upload-file-button.css`);

class UploadFileButton extends Component {

    constructor(props) {
        super(props);
        this.state = {file_name: null,
                      has_file: false};
        this.onUploadHandler = this.onUploadHandler.bind(this);
    }

    onUploadHandler(event) {
      if(event.target.files && (event.target.files.length > 0)){
        this.setState({file_name: event.target.files[0].name,
                       has_file: true});
      }
      this.props.onChange(event);

    }

    render() {

        return (<div className={"upload-wrapper"}>
                  <p>
                    <Button className={"btn btn-warning btn-sm pd-simple-button " + (this.state.has_file ? 'pd-button-accepted-contract' : '')}>{this.state.has_file ? 'Listo!' : 'Subir'}</Button>
                    <input type="file" name={this.props.name} onChange={this.onUploadHandler}/>
                  </p>
                </div>);
    }
}

export default UploadFileButton;



/** WEBPACK FOOTER **
 ** ./src/components/UploadFileButton.js
 **/